import FooterGlassView from './FooterGlassView'

export default FooterGlassView
